<template>
    <div :class="['loading', cssClass]" role="status">
        <div class="loading__icon" v-if="iconClass">
            <i :class="iconClass" aria-hidden="true"></i>
        </div>
        <div class="loading__title" v-if="$slots.title">
            <slot name="title"></slot>
        </div>
        <div class="loading__text" v-if="$slots.text">
            <slot name="text"></slot>
        </div>
        <div class="loading__spinner">
            <div class="three-dot" aria-hidden="true">
                <div class="dot-carousel"></div>
            </div>
            <span v-if="!$slots.title" class="visually-hidden">Loading…</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loading',
        props: {
            cssClass: {type: String, default: ''},
            iconClass: {type: String, default: ''},
        },
    }
</script>
